export default function setTabsToShowSincronizzazione(listTabs) {
  
    return listTabs[0];
  }
  